var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('horizontal-stacked-bar-chart',{attrs:{"chart-data":_vm.employeesByOrganizationSize,"colors":_vm.colors,"custom-group-sorting":_vm.groups,"config":_vm.config,"parent-height":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }